import { combineReducers } from 'redux'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage/session'

import { IntlReducer as Intl } from 'react-redux-multilingual'

import alertReducer from './alert.reducer'
import actionReducer from './action.reducer'
import cartReducer from './cart.reducer'
import configReducer from './config.reducer'
import errorReducer from './error.reducer'
import inventoryReducer from './inventory.reducer'
import loadingReducer from './loading.reducer'
import metaData from './metaData.reducer'
import storeReducer from './store.reducer'

const IntlPersistConfig = {
	key: 'intl',
	storage: storage,
	whitelist: ['locale'],
}

const InventoryPersistConfig = {
	key: 'inventory',
	storage: storage,
	whitelist: [
		'categories',
		'products',
		'allProducts',
		'visibleProducts',
		'totalPages',
		'inventory_settings',
		'selected_category',
		'selected_product',
	],
}

const ConfigurationPersistConfig = {
	key: 'config',
	storage: storage,
	whitelist: [
		'app_seo',
		'catalog_info_loading',
		'catalog_journey_settings',
		'config_info_loading',
		'checkout_language',
		'disableCatalogInfoLoading',
		'last_updated',
		'merchant',
		'merchant_banner_settings',
		'merchant_settings',
		'show_back_btn',
		'catalogue_key',
		'config_info_loaded',
		'config_load_count',
		'additional_details',
	],
}

const CartPersistConfig = {
	key: 'cart',
	storage: storage,
	whitelist: ['customer_details', 'cart_items'],
}

const ErrorPersistConfig = {
	key: 'error',
	storage: storage,
	whitelist: ['message', 'description', 'status'],
}

const StoresPersistConfig = {
	key: 'store',
	storage: storage,
	whitelist: ['allStores', 'stores', 'pageCount', 'totalPages', 'pageIndex', 'pageNumber'],
}

const ActionsPersistConfig = {
	key: 'action',
	storage: storage,
	whitelist: ['showProductDetail'],
}

const rootReducer = combineReducers({
	toast: alertReducer,
	action: persistReducer(ActionsPersistConfig, actionReducer),
	cart: persistReducer(CartPersistConfig, cartReducer),
	config: persistReducer(ConfigurationPersistConfig, configReducer),
	error: persistReducer(ErrorPersistConfig, errorReducer),
	Intl: persistReducer(IntlPersistConfig, Intl),
	loading: loadingReducer,
	meta: metaData,
	inventory: persistReducer(InventoryPersistConfig, inventoryReducer),
	store: persistReducer(StoresPersistConfig, storeReducer),
})

export default rootReducer
